<template>
  <sf-dialog v-model="model" scrollable :width="800">
    <v-card>
      <v-card-item>
        <v-card-title>
          <sf-heading>{{ $t('essentialShopDeactivated.requestActivation') }}</sf-heading>
        </v-card-title>
      </v-card-item>
      <v-card-text class="d-flex flex-column">
        <sf-text class="mb-1">
          {{ $t('essentialShopDeactivated.requestActivationHint') }}
        </sf-text>
        <sf-text-field
          v-model="emailAddress"
          :label="$t('contactData.email')"
          :rules="[rules.mailRule]"
        ></sf-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <sf-text-button color="grey" class="text-medium-emphasis" @click="model = false">
          {{ $t('cancel') }}
        </sf-text-button>
        <sf-text-button
          color="primary"
          :loading="sending"
          :disabled="!emailAddressValid"
          @click="sendRequest(emailAddress)"
        >
          {{ $t('send') }}
        </sf-text-button>
      </v-card-actions>
    </v-card>
  </sf-dialog>
</template>

<script setup lang="ts">
import SfTextButton from '@/components/button/SfTextButton.vue'
import SfTextField from '@/components/input/SfTextField.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import SfText from '@/components/text/SfText.vue'
import SfDialog from '@/components/dialog/SfDialog.vue'
import useEssentialShopActivationRequest from '@/modules/essentialShop/useEssentialShopActivationRequest'
import { computed, ref } from 'vue'
import rules from '@/rules'

const { sending } = useEssentialShopActivationRequest()

const model = defineModel<boolean>({ default: false })

const sendRequest = async (emailAddress: string) => {
  await useEssentialShopActivationRequest().sendEssentialShopActivationRequest(emailAddress)
  model.value = false
}

const emailAddress = ref('')

const emailAddressValid = computed(() => {
  return emailAddress.value && rules.mailRule(emailAddress.value) === true
})
</script>
